import { Label } from '@acast/decibel';
import classnames from 'classnames';
import moment from 'moment';
import T from 'prop-types';
import TimePicker from 'rc-time-picker';
import React, { Component } from 'react';
import isStringISODate from 'shared/helpers/is-string-iso-date';

export default class TimeSelect extends Component {
  static propTypes = {
    selected: T.string,
    label: T.string,
    displayFormat: T.string,
    onChange: T.func,
    disabled: T.bool,
  };

  static defaultProps = {
    selected: null,
    label: '',
    displayFormat: 'HH:mm',
    disabled: false,
    onChange: () => {
      // eslint-disable-next-line
      console.log('TimeInput does not have an onChange callback');
    },
  };

  state = {
    isFocused: false,
  };

  onInputFocus = () => {
    this.setState({ isFocused: true });
  };

  onInputBlur = () => {
    this.setState({ isFocused: false });
  };

  onTimeChange = value => {
    const { onChange } = this.props;
    if (typeof onChange === 'function') {
      onChange(value);
    }
  };

  getInputLabel() {
    const { label } = this.props;
    if (typeof label === 'string' && label.length > 0) {
      return <Label>{label}</Label>;
    }
    return null;
  }

  render() {
    const { selected, displayFormat } = this.props;
    const date = isStringISODate(selected) ? moment(selected) : null;

    return (
      <div className={classnames('time-select', { 'time-select--disabled': this.props.disabled })}>
        {this.getInputLabel()}
        <TimePicker
          value={date}
          placeholder={date && date.isValid() ? '' : '00:00'}
          format={displayFormat}
          showSecond={false}
          className="time-select__input"
          onChange={this.onTimeChange}
        />
      </div>
    );
  }
}
